import { render } from "./BankAccountItem.vue?vue&type=template&id=f27417e0&scoped=true&ts=true"
import script from "./BankAccountItem.vue?vue&type=script&lang=ts"
export * from "./BankAccountItem.vue?vue&type=script&lang=ts"

import "./BankAccountItem.vue?vue&type=style&index=0&id=f27417e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27417e0"]])

export default __exports__